import React, { ReactElement } from "react";
import CorporateDetails from "../../components/Corporate/Details";
import Layout from "../../components/layout";

const CorporateDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <CorporateDetails />
    </Layout>
  );
};

export default CorporateDetailsPage;
